/**
 * Full-page loading skeleton: heading bar, subtitle bar, and a large
 * content block. Renders inside the page's own container/wrapper.
 */
export default function PageLoading() {
  return (
    <div className="animate-pulse space-y-6">
      <div className="h-8 bg-secondary-200 rounded w-1/3"></div>
      <div className="h-6 bg-secondary-200 rounded w-1/2"></div>
      <div className="h-64 bg-secondary-200 rounded"></div>
    </div>
  );
}
